export default __webpack_public_path__ + "static/media/how-it-works_04.4b0429f0.png";